const labelFromItem = (item) => {
  if (item == null) return "";
  if (typeof item === "string") return item.trim();
  if (typeof item === "object") {
    return String(item.label || item.name || item.title || item.value || item.code || "").trim();
  }
  return String(item).trim();
};

const listLabels = (items = []) => (
  Array.isArray(items) ? items.map(labelFromItem).filter(Boolean) : []
);

const summarizeMedication = (entry = {}) => ({
  name: String(entry.name || entry.medicationName || "").trim() || null,
  dosage: String(entry.dosage || entry.dose || "").trim() || null,
  scheduleType: String(entry.scheduleType || "").trim() || null,
  scheduledTimes: Array.isArray(entry.scheduledTimes) ? entry.scheduledTimes.filter(Boolean) : [],
  category: String(entry.category || "").trim() || null,
});

export const buildCareExtractionContext = (child = null) => {
  if (!child) {
    return null;
  }

  const medicationRecords = Array.isArray(child.medicationRecords)
    ? child.medicationRecords
    : (Array.isArray(child.medicalProfile?.medicationRecords)
      ? child.medicalProfile.medicationRecords
      : []);
  const activeMedications = medicationRecords
    .filter((entry) => entry?.name && !entry?.isArchived)
    .map(summarizeMedication);

  return {
    childBasics: {
      childId: child.id || null,
      name: String(child.name || "").trim() || null,
      age: String(child.age || "").trim() || null,
    },
    careContext: {
      subjectType: child.careContext?.subjectType || null,
      ageGroup: child.careContext?.ageGroup || null,
      careFocus: listLabels(child.careContext?.careFocus),
      trackingFocus: listLabels(child.careContext?.trackingFocus),
      careSetting: listLabels(child.careContext?.careSetting),
    },
    medicationContext: {
      activeMedications,
      hasMedicationDetails: activeMedications.length > 0,
    },
  };
};
